import APIService from "@/common/API";
import { parsedUser } from "@/common/GetCurrentUser";
import Filter from "@/components/core/Filter/Filter";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const AgentCustomers = (props: any) => {
    const [records, setRecords] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false);
    const user = parsedUser();
    const [filterObj, setFilterObj] = useState<any>({})
    const { t } = useTranslation();
    const bindData = async () => {
        try {
            console.log(user)
            setLoading(true);
            const request = await APIService.getAction(`customer/list?organizationId=${user.OrganizationId}&userId=${props.ID}&search=${filterObj.search || ""}    `);
            if (request.data.status === "ok") {
                setRecords(request.data.response);
            }
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }
    }
    const getFilterValues = (obj: any) => {
        console.log("obj", obj)
        setFilterObj(obj)
    }

    useEffect(() => {
        if (filterObj && Object.keys(filterObj).length > 0) {
            console.log(filterObj)
            bindData()
        }
    }, [filterObj])
    useEffect(() => {
        bindData();
    }, [])
    return (<>
        <h2>{t("Customers")}</h2>
        {/* FILTER */}
        <Filter fields={[
            {
                name: "search",
                label: t("Search"),
                className: "col-12 col-md-4",
                htmlType: "text",
            },]}
            filterAction={() => {
                bindData()
            }}

            setFilterFields={getFilterValues}
        />
        {/* RESULTS */}
        <div className="card shadow-sm">
            <div className="card-body">
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>{t("Name")}</th>

                                <th>{t("Phone")}</th>
                                <th>{t("Status")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {records.map((record) => (
                                <tr key={record.id}>
                                    <td>{record.customerName}
                                        <br />
                                        <small>{record.customerCode}</small>
                                    </td>

                                    <td>{record.phone}</td>
                                    <td>{record.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    </>);

}

export default AgentCustomers;